module.exports = __webpack_public_path__ + "MehulParakh-bcc774a3.webp";